const OLD_API_BASE = "https://89yabm1gjb.execute-api.ap-southeast-2.amazonaws.com/prod";

function isEnabled(value) {
  return ["1", "true", "yes", "new"].includes(String(value || "").toLowerCase());
}

const explicitApiBase = process.env.REACT_APP_API_BASE;
const useNewApi = isEnabled(process.env.REACT_APP_USE_NEW_API);
const newApiBase = process.env.REACT_APP_NEW_API_BASE;

export const API_BASE = (
  explicitApiBase ||
  (useNewApi && newApiBase) ||
  OLD_API_BASE
).replace(/\/+$/, "");

export function apiUrl(path) {
  const suffix = String(path || "").startsWith("/") ? path : `/${path || ""}`;
  return `${API_BASE}${suffix}`;
}
